module.exports = __webpack_public_path__ + "static/media/logo.5346aa67.svg";